import { Component } from '@angular/core';

@Component({
  selector: 'app-pat-payment-panel-adyen-cb-skeleton',
  templateUrl: './pat-payment-panel-adyen-cb-skeleton.component.html',
})
export class PatPaymentPanelAdyenCbSkeletonComponent {}
